<template>
  <!--
    Redirect shim — single source of truth for the terms of service lives
    at kiey.com/terms.html. This route is kept for back-compat with emails,
    old bookmarks, and links inside admin.kiey.com that still use
    `/terms_and_conditions`.
  -->
  <v-content class="gb">
    <v-container class="fill-width text-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <v-card class="fill-width card-theme" style="padding: 64px 32px;">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p style="margin-top: 16px; color: #5A6A85;">Redirecting to the Kiey Terms of Use…</p>
            <p style="margin-top: 8px; font-size: 13px;">
              If you aren't redirected automatically,
              <a href="https://kiey.com/terms.html">click here</a>.
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<script>
export default {
  name: "terms_and_conditions_redirect",
  created() {
    window.location.replace("https://kiey.com/terms.html");
  },
};
</script>
